import React, { useState } from 'react';
import { Segmented } from '../..';
import { NewSummaryDetailsCard } from '../NewSummaryDetailsCard/NewSummaryDetailsCard';
import { calcModernizationSavingsFromApi } from './osModernizationHelpers';
import classNames from 'classnames';

const YEAR_OPTIONS = ['1yr', '2yr', '3yr'];

export const ModernizationSavingsCard = ({ title, osPricingData, summaryData, className = '', ...props }) => {
    const [yearIndex, setYearIndex] = useState(0);

    const details = calcModernizationSavingsFromApi(osPricingData, summaryData, yearIndex);

    return (
        <NewSummaryDetailsCard
            className={classNames(className, 'modernization-savings-card')}
            title={title}
            details={details}
            headerRight={
                <Segmented
                    options={YEAR_OPTIONS}
                    value={YEAR_OPTIONS[yearIndex]}
                    onChange={(val) => setYearIndex(YEAR_OPTIONS.indexOf(val))}
                    size="small"
                    shape="round"
                />
            }
            {...props}
        />
    );
};
